export default class Modal {
    constructor({
        modal,
        siblings = [],
        title = null, 
        body = null, 
        buttons = [],
        onOpen = null,
        onClose = null, 
    }) {
        for (const [key, value] of Object.entries(arguments[0]))
            this[`_${key}`] = value;

        this._modalBody = this._modal.querySelector(".modal-body");
        this._btnClose = this._modal.querySelector(".btn-close-modal");
        this._modalTitle = this._modal.querySelector(".modal-title");
        this._modalMsg = this._modalBody.querySelector(".modal-msg");
        this._btnsWrap = this._modalBody.querySelector(".btns-wrap");

        if (this._title)
            this._modalTitle.innerHTML = this._title;

        if (this._body)
            this._modalMsg.innerHTML = this._body;

        this._buttons.forEach(btn => this._btnsWrap.appendChild(btn));

        this._modal.addEventListener("close", this._onClose?.bind(this));
        this._modal.addEventListener("click", this.hide.bind(this));
        this._btnClose.addEventListener("click", this.hide.bind(this));
        this._modalBody.addEventListener("click", (e) => e.stopPropagation());
    }

    show() {
        this._siblings.forEach(s => s.setAttribute("inert", ""));
        this._modal.showModal();
        this._onOpen?.();
    }

    hide() {
        this._siblings.forEach(s => s.removeAttribute("inert"));
        this._modal.close();
        this._modal.remove();
    }
}